import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { URLConst } from 'src/app/shared/const/url.const';
import { EnvironmentconfigService } from '../../../shared/service/environmentconfig.service';
import { WebApiService } from 'src/app/shared/service/webapi.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { DateUtil } from 'src/app/shared/utils/date-format.util';
import { BaseComponent } from '../../../shared/base/base.component';
import { MatomoTracker } from 'ngx-matomo';
import { ActivatedRoute, Router } from '@angular/router'
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { filter } from 'rxjs/operators';
import { NzModalService } from 'ng-zorro-antd/modal';
import { TranslateService } from '@ngx-translate/core';

interface ItemData {
  InvoiceSerialNumber: string;
  InvoiceDate: string;
  InvoiceCode: string;
  InvoiceNo: string;
  InvoiceAmountBeforeTax: string;
  Taxes: string;
}
@Component({
  selector: 'app-edit-wmsm-StatementMaintain',
  templateUrl: './edit-wmsm-StatementMaintain.component.html',
  styleUrls: ['./edit-wmsm-StatementMaintain.component.css']
})
export class EditWmsmStatementMaintainComponent extends BaseComponent implements OnInit {
  currency: string = 'RMB'; // 默认值
  loading: boolean = false;
  isShowCondition: boolean = true;
  // 表格每页显示条数,默认每頁顯示10筆資料
  pageSize: number = 20;
  // 表格页码
  pageIndex: number = 1;
  nzTotal: number = 0;
  validateForm: FormGroup;
  validateForm2: FormGroup;
  listOfInvoceData: any[] = [];
  i = 0;
  listOfInvoiceData: any[] = [];
  listOfGoodsData: any[];
  listOfInvoiceItemData: any[] = [];
  editId: Number | null = 0;
  dateFormat = 'yyyy/MM/dd';
  FirstInvoiceDate;
  RNO: string;
  vendorCode: string;
  companyERP: string;
  InvoiceSerialNumberIsNull: boolean = true;
  InvoiceInfo: any[] = [];
  ReceiptInfo: any[] = [];
  SubmitInvoiceInfo: any[] = [];
  SubmitReceiptInfo: any[] = []
  fileList: NzUploadFile[] = [];
  ExcelControl = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ];
  InvoiceInfoSerialNumberList: any[] = [];
  SerialNumberInInvoice: boolean = true;
  count = 0;
  InvoiceCodeIsNull: boolean = true;
  InvoiceNoIsNull: boolean = true;
  foreignAmountsIncomplete: boolean = false;

  constructor(
    private fb: FormBuilder,
    private AuthService: AuthService,
    private Environment: EnvironmentconfigService,
    private WebApiService: WebApiService,
    private NzMessageService: NzMessageService,
    private matomotracker: MatomoTracker,
    private ActivatedRoute: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private modal: NzModalService,
    private translate: TranslateService,
  ) { super() }


  ngOnInit() {
    this.validateForm = this.fb.group({
      aliases: this.fb.array([])
    })
    this.validateForm2 = this.fb.group({
      aliases2: this.fb.array([])
    })
    this.ActivatedRoute.queryParams.subscribe(params => {
      this.RNO = params['rno'];
      this.currency = params['currency'] || 'RMB'; // 获取 currency
      this.vendorCode = params['vendorCode'] || '';
      this.companyERP = params['companyERP'] || '';
    })
    // 非RMB：父組件作容器，但仍需載入收貨清單供下方選擇
    if (this.currency !== 'RMB') {
      this.GetReceipt();
      return;
    }
    // RMB：維持原有行為
    this.GetInvoice();
    this.GetReceipt();
  }

  // FX 子組件的序號列表同步
  onFxSerialsChange(list: string[]): void {
    this.InvoiceInfoSerialNumberList = list || [];
  }
  startEdit(id: Number): void {
    this.editId = id;
  }

  stopEdit(): void {
    this.editId = 0;
  }
  get aliases() {
    return this.validateForm.get('aliases') as FormArray;
  }

  get aliases2() {
    return this.validateForm2.get('aliases2') as FormArray;
  }

  /**
   * 啟用手動編輯模式
   * @param index 行索引
   */
  enableManualEdit(index: number): void {
    const control = this.aliases.at(index) as FormGroup;
    if (control) {
      control.get('editMode').setValue('editing');
      control.get('isLocked')?.setValue(false);
      this.setManualFieldState(control, false);
      this.NzMessageService.info(this.translate.instant('MsgRowEditable', { index: index + 1 }));
      this.updateForeignAmountCompleteness();
    }
  }

  addRow(): void {
    const newSerialNumber = this.aliases.length + 1;

    const newRow = this.fb.group({
      InvoiceSerialNumber: [{ value: newSerialNumber, disabled: true }, [Validators.required]],
      InvoiceDate: [null, [Validators.required]],
      InvoiceCode: [''],
      InvoiceNo: [null, [Validators.required]],
      InvoiceAmountBeforeTax: [null, [Validators.required]],
      Taxes: [null, [Validators.required]],
      TotalAmount: [{ value: '', disabled: true }],
      parsedTotalAmount: [null],
      userDecision: ['pending'],
      editMode: ['initial'],
      recognizedData: [null],
      isLocked: [false],
    });

    if (this.currency !== 'RMB') {
      newRow.get('InvoiceAmountBeforeTax').disable();
      newRow.get('Taxes').disable();
    }

    this.aliases.push(newRow);

    // 【核心修改】新增行後，立即更新下拉選單
    this.updateSerialNumberList();
    this.updateForeignAmountCompleteness();
  }

  deleteRow(index: any): void {
    this.removeFormArrayItem(index);
  }

  //删除表单组
  removeFormArrayItem(index: any) {
    // 步驟 1：在刪除之前，先獲取將要被刪除的發票序號
    // 使用 .getRawValue() 確保能讀取到被禁用的欄位值
    const deletedSerialNumber = this.aliases.at(index).getRawValue().InvoiceSerialNumber;

    // 步驟 2：從 FormArray 中移除該發票行
    this.aliases.removeAt(index);

    // 步驟 3：更新下拉選單的【選項列表】
    this.updateSerialNumberList();

    // 【【【 核心修改點 】】】
    // 步驟 4：遍歷下方的收貨清單，清空所有與已刪除序號的關聯
    if (deletedSerialNumber != null && this.listOfGoodsData) {
      for (let i = 0; i < this.listOfGoodsData.length; i++) {
        // 如果收貨項目的 invoiceItem 正好是被刪除的那個序號
        if (this.listOfGoodsData[i].invoiceItem == deletedSerialNumber) {
          // 將其清空
          this.listOfGoodsData[i].invoiceItem = null;
          this.listOfInvoiceItemData[i] = null;
        }
      }
    }

    // 步驟 5：在清理完畢後，重新檢查收貨清單的必填狀態
    this.CheckInvoiceItem();
    this.updateForeignAmountCompleteness();
  }
  SaveData() {
    for (const i in this.validateForm.controls) {
      if (this.validateForm.controls.hasOwnProperty(i)) {
        this.validateForm.controls[i].markAsDirty();
        this.validateForm.controls[i].updateValueAndValidity();
      }
    }
    for (const row of this.aliases.getRawValue()) {
      if (row.InvoiceNo != '' && row.InvoiceNo != null) {
        this.InvoiceInfo.push({
          Rno: this.RNO,
          InvoiceItem: row.InvoiceSerialNumber, // <-- 現在可以正確獲取
          InvoiceDate: this.getTheDateString_(row.InvoiceDate),
          InvoiceCode: row.InvoiceCode,
          Invoice: row.InvoiceNo,
          InvoiceAmount: row.InvoiceAmountBeforeTax,
          TaxAmount: row.Taxes,
        });
      }
    }
    for (let i = 0; i < this.listOfGoodsData.length; i++) {
      let invoiceItem = null;
      if (this.listOfGoodsData[i].invoiceItem != '' && this.listOfGoodsData[i].invoiceItem != null) {
        invoiceItem = this.listOfGoodsData[i].invoiceItem.toString();
      }
      this.ReceiptInfo.push({
        RNo: this.RNO,
        InvoiceItem: invoiceItem,
        Company: this.listOfGoodsData[i].companyCode,
        PoNo: this.listOfGoodsData[i].pono,
        PoLn: this.listOfGoodsData[i].poln,
        RtNo: this.listOfGoodsData[i].rtno,
        RtLn: this.listOfGoodsData[i].rtln,
      })
    }
    this.saveData();
  }

  AsFirst(value: string) {
    if (value == 'InvoiceDate') {
      if (this.aliases.controls.length > 0) {
        const firstDate = this.aliases.controls[0].value.InvoiceDate;
        for (let i = 1; i < this.aliases.controls.length; i++) {
          this.aliases.controls[i]['controls']['InvoiceDate'].setValue(firstDate);
        }
      }
    }
    if (value == 'InvoiceCode') {
      if (this.aliases.controls.length > 0) {
        const firstCode = this.aliases.controls[0].value.InvoiceCode;
        for (let i = 1; i < this.aliases.controls.length; i++) {
          this.aliases.controls[i]['controls']['InvoiceCode'].setValue(firstCode);
        }
      }
    }
    if (value == 'invoiceItem') {
      // 【核心修改】使用數據模型進行操作，而不是 DOM
      if (this.listOfGoodsData && this.listOfGoodsData.length > 0) {
        // 獲取第一行的選中值
        const firstValue = this.listOfInvoiceItemData[0];
        // 將第一行的值賦給後面的所有行
        for (let i = 1; i < this.listOfGoodsData.length; i++) {
          this.listOfInvoiceItemData[i] = firstValue;
          this.listOfGoodsData[i].invoiceItem = firstValue;
        }
        // 統一檢查狀態
        this.CheckInvoiceItem();
      }
    }
  }

  //页面跳转时加载收货清单
  GetReceipt() {
    this.loading = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetReceiptListDto.url}`;
    const params = {
      pageSize: this.pageSize,
      pageIndex: this.pageIndex,
      data: {
        Rno: this.RNO,
        RoleType: '' //後端會重取
      },
    };
    this.WebApiService.doPost(url, params).subscribe(
      (res) => {
        if (
          res &&
          res.status == this.Environment.authConfig.wmsmStatus
        ) {
          this.listOfGoodsData = res.data.map((item) => {
            item.rtDate = DateUtil.formatYMD(item.rtDate);
            return item;
          });
          this.nzTotal = res.total;
          this.NzMessageService.success(res.msg);

          // 【核心修改】將資料模型從二維陣列改為一維陣列
          this.listOfInvoiceItemData = []; // 先清空
          for (let index = 0; index < this.listOfGoodsData.length; index++) {
            // 直接將後端返回的單一值(或null)推入陣列
            this.listOfInvoiceItemData.push(this.listOfGoodsData[index].invoiceItem);
          }

        } else {
          this.nzTotal = 0;
          this.NzMessageService.warning(res.msg);
        }
        this.CheckInvoiceItem();
        this.checkInvoiceInfo();
        this.updateForeignAmountCompleteness();
        this.loading = false;
      },
      (error) => {
        this.NzMessageService.error(error.msg);
        this.updateForeignAmountCompleteness();
        this.loading = false;
      }
    );
  }

  repeat(array) {
    for (var i = 0; i < array.length; i++) {
      for (var j = i + 1; j < array.length; j++) {
        if (array[i] === array[j]) {
          array.splice(j, 1);
          j--;
        }
      }
    }
    return array;
  }

  // 【請用下面的程式碼完整替換您現有的 GetInvoice() 函式】

  //页面跳转时加载发票信息
  GetInvoice() {
    this.loading = true;
    const invoiceUrlConst = this.currency !== 'RMB'
      ? URLConst.GettForeignInvoiceInfoListDto
      : URLConst.GetInvoiceInfoListDto;
    const url = `${this.Environment.authConfig.wmsmUrl}${invoiceUrlConst.url}`;
    const params = {
      pageSize: this.pageSize,
      pageIndex: this.pageIndex,
      data: {
        Rno: this.RNO,
        RoleType: '' //後端會重取
      },
    };
    this.WebApiService.doPost(url, params).subscribe(
      (res) => {
        this.loading = false;
        if (res && res.status == this.Environment.authConfig.wmsmStatus) {
          this.nzTotal = res.total;

          // 清空現有行，準備重新填充
          while (this.aliases.length > 0) {
            this.aliases.removeAt(0);
          }

          if (res.data && res.data.length > 0) {
            this.listOfInvoiceData = res.data.map((item) => {
              item.invoiceDate = DateUtil.formatYMD(item.invoiceDate);
              return item;
            });

            const isForeignCurrency = this.currency !== 'RMB';
            const shouldDefaultLock = isForeignCurrency && this.listOfInvoiceData.length > 0;
            const defaultEditMode = isForeignCurrency ? 'editing' : 'initial';

            // 遍歷 API 數據，創建表單行
            for (const invoice of this.listOfInvoiceData) {
              if (isForeignCurrency) {
                const recognizedInvoiceNo = invoice.invoice || null;
                const recognizedInvoiceDateObj = invoice.invoiceDate ? new Date(invoice.invoiceDate) : null;
                const recognizedInvoiceDateStr = recognizedInvoiceDateObj ? DateUtil.formatYMD(recognizedInvoiceDateObj) : null;
                const recognizedTotal = invoice.invoiceTotal !== undefined && invoice.invoiceTotal !== null
                  ? parseFloat(invoice.invoiceTotal)
                  : null;

                const manualInvoiceNo = invoice.manualInvoiceNumber || recognizedInvoiceNo;
                const manualInvoiceDateObj = invoice.manualInvoiceDate ? new Date(invoice.manualInvoiceDate) : recognizedInvoiceDateObj;
                const manualInvoiceDateStr = manualInvoiceDateObj ? DateUtil.formatYMD(manualInvoiceDateObj) : null;
                const manualInvoiceAmountRaw = invoice.manualInvoiceAmount ?? null;
                const manualTaxAmountRaw = invoice.manualTaxAmount ?? null;
                const manualInvoiceAmount = manualInvoiceAmountRaw ?? invoice.invoiceAmount ?? null;
                const manualTaxAmount = manualTaxAmountRaw ?? invoice.taxAmount ?? null;
                const manualTotalSource = invoice.manualInvoiceTotal ?? null;
                const manualTotal = manualTotalSource ?? (recognizedTotal !== null ? recognizedTotal : null);

                const amountInputValue = this.formatManualNumberForInput(manualInvoiceAmountRaw ?? manualInvoiceAmount);
                const taxInputValue = this.formatManualNumberForInput(manualTaxAmountRaw ?? manualTaxAmount);
                const totalInputValue = this.formatManualNumberForInput(manualTotalSource ?? manualTotal);

                const hasManualOverride = (
                  (manualInvoiceNo && manualInvoiceNo !== recognizedInvoiceNo) ||
                  (manualInvoiceDateStr && manualInvoiceDateStr !== recognizedInvoiceDateStr) ||
                  (manualTotal !== null && recognizedTotal !== null && Math.abs(manualTotal - recognizedTotal) > 0.000001) ||
                  (manualInvoiceAmount !== null && invoice.invoiceAmount !== null && manualInvoiceAmount !== invoice.invoiceAmount) ||
                  (manualTaxAmount !== null && invoice.taxAmount !== null && manualTaxAmount !== invoice.taxAmount)
                );

                const recognizedPayload = (recognizedInvoiceNo || recognizedInvoiceDateObj || recognizedTotal !== null)
                  ? {
                    invoiceNo: recognizedInvoiceNo,
                    invoiceDate: recognizedInvoiceDateObj,
                    totalAmount: recognizedTotal
                  }
                  : null;

                const newRow = this.fb.group({
                  InvoiceSerialNumber: [{ value: invoice.invoiceItem, disabled: true }, [Validators.required]],
                  InvoiceDate: [{ value: manualInvoiceDateStr, disabled: shouldDefaultLock }, [Validators.required]],
                  InvoiceCode: [invoice.invoiceCode],
                  InvoiceNo: [{ value: manualInvoiceNo, disabled: shouldDefaultLock }, [Validators.required]],
                  InvoiceAmountBeforeTax: [{ value: amountInputValue, disabled: shouldDefaultLock }, [Validators.required]],
                  Taxes: [{ value: taxInputValue, disabled: shouldDefaultLock }, [Validators.required]],
                  TotalAmount: [{ value: totalInputValue, disabled: shouldDefaultLock }],
                  parsedTotalAmount: [recognizedTotal],
                  userDecision: [hasManualOverride ? 'user' : 'pending'],
                  editMode: [defaultEditMode],
                  recognizedData: [recognizedPayload],
                  isLocked: [shouldDefaultLock],
                });

                this.aliases.push(newRow);
              } else {
                const newRow = this.fb.group({
                  InvoiceSerialNumber: [{ value: invoice.invoiceItem, disabled: true }, [Validators.required]],
                  InvoiceDate: [invoice.invoiceDate, [Validators.required]],
                  InvoiceCode: [invoice.invoiceCode],
                  InvoiceNo: [invoice.invoice, [Validators.required]],
                  InvoiceAmountBeforeTax: [invoice.invoiceAmount, [Validators.required]],
                  Taxes: [invoice.taxAmount, [Validators.required]],
                  TotalAmount: [invoice.totalAmount || ''],
                  parsedTotalAmount: [null],
                  userDecision: ['pending'],
                  editMode: ['initial'],
                  recognizedData: [null],
                  isLocked: [false],
                });
                this.aliases.push(newRow);
              }
            }
            this.NzMessageService.success(res.msg);

          } else {
            // 如果 API 沒有返回數據，新增一個空行
            this.addRow();
          }

          // 【核心修改】所有行處理完畢後，統一更新下拉選單
          this.updateSerialNumberList();
          this.updateForeignAmountCompleteness();

        } else {
          this.listOfInvoiceData = [];
          this.nzTotal = 0;
          this.NzMessageService.warning(res.msg);
          this.addRow();
          this.updateSerialNumberList(); // 即使失敗也要更新
          this.updateForeignAmountCompleteness();
        }
      },
      (error) => {
        this.NzMessageService.error(error.msg);
        this.loading = false;
        this.addRow();
        this.updateSerialNumberList(); // 即使出錯也要更新
        this.updateForeignAmountCompleteness();
      }
    );
  }


  //收货清单的发票序号改变时
  GoodsinvoiceItemValueChange(value: string | null, index: number) {
    // 'value' 現在是單一的序號字串或 null
    this.listOfGoodsData[index].invoiceItem = value;
    this.CheckInvoiceItem();
  }
  //发票信息的发票序号改变时
  // invoiceItemValueChange() {
  //   this.InvoiceInfoSerialNumberList = []
  //   for (const i in this.validateForm.controls) {
  //     if (this.validateForm.controls.hasOwnProperty(i)) {
  //       this.validateForm.controls[i].markAsDirty();
  //       this.validateForm.controls[i].updateValueAndValidity();
  //     }
  //   }
  //   for (let i = 0; i < this.validateForm.value.aliases.length; i++) {
  //     if (this.validateForm.value.aliases[i].InvoiceSerialNumber != '') {
  //       this.InvoiceInfoSerialNumberList.push(this.validateForm.value.aliases[i].InvoiceSerialNumber);
  //     }
  //   }
  //   this.InvoiceInfoSerialNumberList = this.repeat(this.InvoiceInfoSerialNumberList);
  //   this.checkInvoiceInfo();
  // }
  saveData() {
    this.loading = true;

    // 清空舊數據，準備填充新數據
    this.InvoiceInfo = [];
    this.ReceiptInfo = [];

    const isForeignCurrency = this.currency !== 'RMB';

    // 使用 getRawValue() 來獲取包含禁用欄位的完整數據
    const invoiceRows = this.aliases.getRawValue();

    // 準備發票信息 (InvoiceInfo)
    for (const row of invoiceRows) {

      // 只要有發票號碼，我們就嘗試保存這一行
      if (row.InvoiceNo != '' && row.InvoiceNo != null) {

        // 輔助函式：將表單中的字串值轉換為後端需要的 number 或 null
        const parseToDecimalOrNull = (value: any): number | null => {
          if (value === null || value === '' || isNaN(parseFloat(value))) {
            return null;
          }
          return parseFloat(value);
        };

        const manualInvoiceNumber = row.InvoiceNo || null;
        const trimmedManualInvoiceNumber = manualInvoiceNumber ? manualInvoiceNumber.trim() : manualInvoiceNumber;
        const manualInvoiceDate = this.formatDateToYYYYMMDD(row.InvoiceDate);
        const parsedManualInvoiceAmount = parseToDecimalOrNull(row.InvoiceAmountBeforeTax);
        const parsedManualTaxAmount = parseToDecimalOrNull(row.Taxes);
        const parsedManualTotalAmount = parseToDecimalOrNull(row.TotalAmount);
        const recognizedTotalAmountValue = parseToDecimalOrNull(row.parsedTotalAmount);

        const recognizedData = row.recognizedData || null;
        const recognizedInvoiceNo = recognizedData?.invoiceNo || null;
        const recognizedInvoiceDate = recognizedData?.invoiceDate
          ? this.formatDateToYYYYMMDD(recognizedData.invoiceDate)
          : null;
        const recognizedTotalAmount = parseToDecimalOrNull(row.parsedTotalAmount);

        const resolvedInvoiceNo = recognizedInvoiceNo || trimmedManualInvoiceNumber;
        const resolvedInvoiceDate = recognizedInvoiceDate || manualInvoiceDate;

        // 從附件列表中提取 FileId (如果有的話)
        const attachments = row.attachmentList || [];
        const fileWithId = attachments.find(att => att.fileId);
        const fileId = fileWithId ? fileWithId.fileId : null;

        // 決定要提交的總額：優先使用手動輸入的 TotalAmount，其次用計算值，最後才用識別值
        const computedTotalAmount = (
          (parsedManualInvoiceAmount ?? 0) + (parsedManualTaxAmount ?? 0)
        );
        const resolvedTotalAmount = (
          parsedManualTotalAmount !== null && parsedManualTotalAmount !== undefined
            ? parsedManualTotalAmount
            : (isForeignCurrency ? computedTotalAmount : computedTotalAmount)
        );

        const invoicePayload: any = {
          Rno: this.RNO,
          InvoiceItem: row.InvoiceSerialNumber != null ? row.InvoiceSerialNumber.toString() : null,
          InvoiceDate: resolvedInvoiceDate,
          InvoiceCode: row.InvoiceCode,
          Invoice: resolvedInvoiceNo,
          InvoiceAmount: parsedManualInvoiceAmount,
          TaxAmount: parsedManualTaxAmount,
          // 僅在非 RMB 時傳遞 InvoiceTotal；RMB 保持原邏輯不傳或為空
          InvoiceTotal: isForeignCurrency ? (parsedManualTotalAmount ?? recognizedTotalAmountValue ?? resolvedTotalAmount) : null,
          FileId: fileId
        };

        if (isForeignCurrency) {
          let isManualEdited = false;

          invoicePayload.ManualInvoiceNumber = null;
          invoicePayload.ManualInvoiceAmount = null;
          invoicePayload.ManualTaxAmount = null;
          invoicePayload.ManualInvoiceTotal = null;
          invoicePayload.ManualInvoiceDate = null;

          if (recognizedInvoiceNo && trimmedManualInvoiceNumber && trimmedManualInvoiceNumber !== recognizedInvoiceNo) {
            invoicePayload.ManualInvoiceNumber = trimmedManualInvoiceNumber;
            isManualEdited = true;
          }

          if (recognizedInvoiceDate && manualInvoiceDate && manualInvoiceDate !== recognizedInvoiceDate) {
            invoicePayload.ManualInvoiceDate = manualInvoiceDate;
            isManualEdited = true;
          }

          if (
            recognizedTotalAmount != null &&
            parsedManualTotalAmount != null &&
            Math.abs(recognizedTotalAmount - parsedManualTotalAmount) > 0.000001
          ) {
            invoicePayload.ManualInvoiceTotal = parsedManualTotalAmount;
            isManualEdited = true;
          }

          if (row.userDecision === 'user') {
            if (parsedManualInvoiceAmount != null) {
              invoicePayload.ManualInvoiceAmount = parsedManualInvoiceAmount;
              isManualEdited = true;
            }
            if (parsedManualTaxAmount != null) {
              invoicePayload.ManualTaxAmount = parsedManualTaxAmount;
              isManualEdited = true;
            }
            if (parsedManualTotalAmount != null && invoicePayload.ManualInvoiceTotal === null) {
              invoicePayload.ManualInvoiceTotal = parsedManualTotalAmount;
            }
          }

          if (!isManualEdited && row.userDecision === 'user') {
            isManualEdited = true;
          }

          invoicePayload.IsManualEdited = isManualEdited;
        } else {
          invoicePayload.IsManualEdited = false;
        }

        this.InvoiceInfo.push(invoicePayload);
      }
    }

    // 準備收貨清單信息 (ReceiptInfo) - 這部分邏輯已正確，保持不變
    for (let i = 0; i < this.listOfGoodsData.length; i++) {
      let invoiceItem = null;
      if (this.listOfGoodsData[i].invoiceItem != '' && this.listOfGoodsData[i].invoiceItem != null) {
        invoiceItem = this.listOfGoodsData[i].invoiceItem.toString();
      }
      this.ReceiptInfo.push({
        RNo: this.RNO,
        InvoiceItem: invoiceItem,
        Company: this.listOfGoodsData[i].companyCode,
        PoNo: this.listOfGoodsData[i].pono,
        PoLn: this.listOfGoodsData[i].poln,
        RtNo: this.listOfGoodsData[i].rtno,
        RtLn: this.listOfGoodsData[i].rtln,
      });
    }

    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.MaintainInvoiceInfo.url}`;
    const params = {
      data: {
        InvoiceInfoList: this.InvoiceInfo,
        ReceiptInfoList: this.ReceiptInfo,
        RNo: this.RNO,
        Currency: this.currency
      },
    };

    this.WebApiService.doPost(url, params).subscribe(
      (res) => {
        if (res && res.status == this.Environment.authConfig.wmsmStatus) {
          this.NzMessageService.success(res.msg);
          this.AuthService.StatementMaintainData = null;
        } else {
          this.NzMessageService.error(res.msg);
        }
        this.loading = false;
      },
      (error) => {
        this.NzMessageService.error(error.msg || '儲存數據時發生錯誤。');
        this.loading = false;
      }
    ).add(() => {
      // 無論成功或失敗，都清空暫存陣列，防止重複提交舊數據
      this.InvoiceInfo = [];
      this.ReceiptInfo = [];
    });
  }

  formatDateToYYYYMMDD(date: Date | string): string {
    if (!date) return null;

    const d = new Date(date);
    const year = d.getFullYear();
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const day = d.getDate().toString().padStart(2, '0');

    return `${year}-${month}-${day}`;
  }


  Retrun() {
    this.router.navigate(["/pages/wmsm-pages/SupplierManagement/StatementPaymentManagement/wmsmStatementMaintain"]);
  }

  exportTableToExecl() {
    this.loading = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.DownLoadRtStatementMatainExcel.url}`;
    const params = {
      data: {
        Rno: this.RNO,
        RoleType: '', //後端會重取
      },
    };
    this.WebApiService.doPost(url, params, true).subscribe((res) => {
      this.downloadFile8(res, `wmsm_MaintainStatement${this.getTimeString()}.xlsx`);
      this.loading = false;
    });
  }

  beforeUpload = (file: NzUploadFile): boolean => {
    this.saveExcelData(file);
    return false;
  };

  saveExcelData(file) {
    this.loading = true;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('rno', this.RNO);
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.UploadRtAcDetailInvoice.url}`;
    const _headers = new HttpHeaders().set(
      'Authorization',
      'Bearer ' + this.AuthService.getToken()
    ).set('IdentityType', this.AuthService.getCurrentUserInfo()?.userType || '');
    const req = new HttpRequest('POST', url, formData, {
      headers: _headers,
    });
    this.http
      .request(req)
      .pipe(filter((e) => e instanceof HttpResponse))
      .subscribe(
        (res) => {
          const body = res['body'] as any;
          if (body.status == this.Environment.authConfig.wmsmStatus) {
            while (this.aliases.length > 0) {
              this.aliases.removeAt(0);
            }
            for (let i = 0; i < body.data.invoiceInfoList.length; i++) {
              this.addRow();
            }
            for (let i = 0; i < this.aliases.controls.length; i++) {
              const invoice = body.data.invoiceInfoList[i];
              this.aliases.at(i).patchValue({
                // 注意：序號由 addRow 自動生成，Excel 中的序號僅用於關聯，不覆蓋UI
                // InvoiceSerialNumber: invoice.invoiceItem,
                InvoiceDate: invoice.invoiceDate,
                InvoiceCode: invoice.invoiceCode,
                InvoiceNo: invoice.invoice,
                InvoiceAmountBeforeTax: invoice.invoiceAmount,
                Taxes: invoice.taxAmount,
              });
            }

            // 【核心修改】Excel 導入後，統一更新下拉選單
            this.updateSerialNumberList();

            this.listOfInvoiceItemData = [];
            for (let i = 0; i < body.data.receiptInfoList.length; i++) {
              this.listOfGoodsData[i].invoiceItem = body.data.receiptInfoList[i].invoiceItem;
              if (this.listOfGoodsData[i].invoiceItem != null && this.listOfGoodsData[i].invoiceItem.indexOf(',') !== -1) {
                let arr = this.listOfGoodsData[i].invoiceItem.split(',');
                this.listOfInvoiceItemData.push(arr);
              } else if (this.listOfGoodsData[i].invoiceItem != null) {
                this.listOfInvoiceItemData.push([this.listOfGoodsData[i].invoiceItem]);
              }
            }
            this.NzMessageService.success(body.msg);
          } else {
            this.NzMessageService.warning(body.msg);
          }
          this.CheckInvoiceItem();
          this.updateForeignAmountCompleteness();
          this.loading = false;
        },
        (error) => {
          this.NzMessageService.error('upload failed.');
          this.updateForeignAmountCompleteness();
          this.loading = false;
        }
      );
  }

  Submit() {
    this.loading = true;

    // ... 表單驗證部分保持不變 ...
    for (const i in this.validateForm.controls) {
      if (this.validateForm.controls.hasOwnProperty(i)) {
        this.validateForm.controls[i].markAsDirty();
        this.validateForm.controls[i].updateValueAndValidity();
      }
    }
    if (this.validateForm.invalid) {
      this.NzMessageService.warning(this.translate.instant('Please fill in all required fields correctly.'));
      this.loading = false;
      return;
    }

    this.SubmitInvoiceInfo = [];
    this.SubmitReceiptInfo = [];

    const invoiceRows = this.aliases.getRawValue();

    for (const row of invoiceRows) {
      const parseToDecimalOrNull = (value: any): number | null => {
        if (value === null || value === '' || isNaN(parseFloat(value))) {
          return null;
        }
        return parseFloat(value);
      };

      // 【【【 核心修正：萬無一失的日期處理 】】】
      let finalInvDate: Date | null = null;
      if (row.InvoiceDate) {
        // 不論 row.InvoiceDate 是 Date 物件還是任何格式的日期字串，都嘗試用 new Date() 解析
        const d = new Date(row.InvoiceDate);
        // 檢查解析出來的日期是否有效
        if (!isNaN(d.getTime())) {
          finalInvDate = d;
        }
      }
      const formattedDate = this.formatDateToYYYYMMDD(finalInvDate);

      const recognized = row.recognizedData || null;
      const recognizedInvoiceNo = recognized?.invoiceNo || null;
      const recognizedDateStr = recognized?.invoiceDate ? this.formatDateToYYYYMMDD(recognized.invoiceDate) : null;
      const manualInvoiceNo = row.InvoiceNo || null;
      const manualDateStr = formattedDate || null;

      let isManualEditedFlag = false;
      if (this.currency !== 'RMB') {
        // 標記條件：與識別值不同，或使用者選擇 user 决策
        const amountVal = parseToDecimalOrNull(row.InvoiceAmountBeforeTax);
        const taxVal = parseToDecimalOrNull(row.Taxes);
        const totalVal = parseToDecimalOrNull(row.TotalAmount);
        const recognizedTotalVal = parseToDecimalOrNull(row.parsedTotalAmount);

        const diffInvoiceNo = !!(recognizedInvoiceNo && manualInvoiceNo && recognizedInvoiceNo !== manualInvoiceNo);
        const diffDate = !!(recognizedDateStr && manualDateStr && recognizedDateStr !== manualDateStr);
        const diffTotal = (
          recognizedTotalVal != null && totalVal != null && Math.abs(recognizedTotalVal - totalVal) > 0.000001
        );

        isManualEditedFlag = (row.userDecision === 'user') || diffInvoiceNo || diffDate || diffTotal;
      }

      this.SubmitInvoiceInfo.push({
        InvoiceItem: row.InvoiceSerialNumber.toString(),
        Invdate: formattedDate,
        Invcode: row.InvoiceCode,
        Invno: row.InvoiceNo,
        Amount: parseToDecimalOrNull(row.InvoiceAmountBeforeTax),
        Taxamount: parseToDecimalOrNull(row.Taxes),
        IsManualEdited: !!isManualEditedFlag
      });
    }

    // ... 準備 SubmitReceiptInfo 和發送請求的部分保持不變 ...
    for (let i = 0; i < this.listOfGoodsData.length; i++) {
      const item = this.listOfGoodsData[i];
      this.SubmitReceiptInfo.push({
        InvoiceItem: item.invoiceItem ? item.invoiceItem.toString() : null,
        Company: item.companyCode,
        Pono: item.pono,
        Poitemno: item.poln,
        Price: item.finalPrice,
        Rtno: item.rtno,
        Rtitemno: item.rtln,
        Qty: item.rtQty,
        Curr: item.currency,
        Oamount: item.rtAmount,
        Tax: item.taxRate,
        Plantcode: item.plantCode,
        Afamount: item.invoiceAmount,
        Invseq: item.remark,
        Spec: item.spec
      });
    }

    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.SubmitRtStatement.url}`;
    const params = {
      data: {
        RtStatementDetail: this.SubmitReceiptInfo,
        InvoiceInfo: this.SubmitInvoiceInfo,
        Rno: this.RNO,
        Currency: this.currency,
        CompanyNo: this.companyERP,
        VendorCode: this.vendorCode
      },
    };

    this.WebApiService.doPost(url, params).subscribe(
      (res) => {
        if (res && res.status == this.Environment.authConfig.wmsmStatus) {
          this.NzMessageService.success(res.msg);
          this.Retrun();
          this.AuthService.StatementMaintainData = null;
        } else {
          this.NzMessageService.error(res.msg || 'Submit failed with an unknown error.');
        }
        this.loading = false;
      },
      (error) => {
        console.error('Submit failed:', error);
        const errorMsg = error.error?.title || error.msg || 'An API error occurred during submission.';
        this.NzMessageService.error(errorMsg);
        this.loading = false;
      }
    ).add(() => {
      this.SubmitInvoiceInfo = [];
      this.SubmitReceiptInfo = [];
    });
  }





  // 最终提交数据的方法
  finalizeSubmit() {
    this.SubmitInvoiceInfo = [];
    this.SubmitReceiptInfo = [];

    // 准备发票信息
    for (let i = 0; i < this.validateForm.value.aliases.length; i++) {
      const row = this.validateForm.value.aliases[i];
      const invoiceData = {
        InvoiceItem: row.InvoiceSerialNumber,
        Invdate: this.getTheDateString_(row.InvoiceDate),
        Invcode: row.InvoiceCode,
        Invno: row.InvoiceNo,
        Amount: row.InvoiceAmountBeforeTax,
        Taxamount: row.Taxes,
      };

      // 如果有附件，添加单个附件ID (API改动后只支持单个文件)
      if (row.attachmentList && row.attachmentList.length > 0) {
        const fileId = row.attachmentList.find(att => att.fileId)?.fileId;
        if (fileId) {
          invoiceData['FileId'] = fileId;
        }
      }

      this.SubmitInvoiceInfo.push(invoiceData);
    }

    // 准备收货清单
    for (let i = 0; i < this.listOfGoodsData.length; i++) {
      this.SubmitReceiptInfo.push({
        InvoiceItem: this.listOfGoodsData[i].invoiceItem.toString(),
        Company: this.listOfGoodsData[i].companyCode,
        Pono: this.listOfGoodsData[i].pono,
        Poitemno: this.listOfGoodsData[i].poln,
        Price: this.listOfGoodsData[i].finalPrice,
        Rtno: this.listOfGoodsData[i].rtno,
        Rtitemno: this.listOfGoodsData[i].rtln,
        Qty: this.listOfGoodsData[i].rtQty,
        Curr: this.listOfGoodsData[i].currency,
        Oamount: this.listOfGoodsData[i].rtAmount,
        Tax: this.listOfGoodsData[i].taxRate,
        Plantcode: this.listOfGoodsData[i].plantCode,
        Afamount: this.listOfGoodsData[i].invoiceAmount,
        Invseq: this.listOfGoodsData[i].remark
      });
    }

    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.SubmitRtStatement.url}`;
    const params = {
      data: {
        RtStatementDetail: this.SubmitReceiptInfo,
        InvoiceInfo: this.SubmitInvoiceInfo,
        Rno: this.RNO
      },
    };

    this.WebApiService.doPost(url, params).subscribe((res) => {
      if (res && res.status == this.Environment.authConfig.wmsmStatus) {
        this.NzMessageService.success(res.msg);
        this.Retrun();
        this.AuthService.StatementMaintainData = null;
      } else {
        this.NzMessageService.error(res.msg);
      }
      this.loading = false;
    });
  }

  // 檢查收貨清單的發票序號是否為空
  CheckInvoiceItem() {
    // 如果沒有收貨清單數據，視為完整，不應阻擋提交
    if (!this.listOfGoodsData || this.listOfGoodsData.length === 0) {
      this.SerialNumberInInvoice = false;
      return;
    }

    // 同樣使用 .some() 檢查是否「存在」任何一個未選擇發票序號的項
    this.SerialNumberInInvoice = this.listOfGoodsData.some(item =>
      item.invoiceItem === '' || item.invoiceItem === null
    );
  }

  // 檢查發票信息的發票序號是否為空
  checkInvoiceInfo() {
    // 如果沒有任何發票行，視為不完整，禁用提交
    if (this.aliases.controls.length === 0) {
      this.InvoiceSerialNumberIsNull = true;
      return;
    }

    // 使用 getRawValue() 來獲取包含禁用欄位在內的所有值
    const invoiceValues = this.aliases.getRawValue();

    // 使用 Array.prototype.some() 來檢查是否「存在」任何一個不合規的行
    // 只要找到一個序號為空或null的行，some() 就會返回 true
    this.InvoiceSerialNumberIsNull = invoiceValues.some(invoice =>
      invoice.InvoiceSerialNumber === '' || invoice.InvoiceSerialNumber === null
    );
  }

  InvoiceCodeChange() {
    for (let i = 0; i < this.validateForm.value.aliases.length; i++) {
      if (this.validateForm.value.aliases[i].InvoiceCode == '' || this.validateForm.value.aliases[i].InvoiceCode == null) {
        this.InvoiceCodeIsNull = true;
        return;
      }
      else {
        this.InvoiceCodeIsNull = false;
      }
    }
  }

  InvoiceNoChange() {
    for (let i = 0; i < this.validateForm.value.aliases.length; i++) {
      if (this.validateForm.value.aliases[i].InvoiceNo == '' || this.validateForm.value.aliases[i].InvoiceNo == null) {
        this.InvoiceNoIsNull = true;
        return;
      }
      else {
        this.InvoiceNoIsNull = false;
      }
    }
  }

  async beforeUploadAttachment(index: number, file: NzUploadFile): Promise<boolean> {
    this.loading = true;
    const control = this.aliases.at(index);
    // ... (formData 準備部分不變)
    const formData = new FormData();
    formData.append('CompanyERP', this.companyERP || '');
    formData.append('VendorCode', this.vendorCode || '');
    formData.append('InvoiceNo', control.get('InvoiceNo').value || '');
    const invoiceDate = control.get('InvoiceDate').value;
    formData.append('InvoiceDate', invoiceDate ? this.getTheDateString_(invoiceDate) : '');
    formData.append('NetAmount', control.get('InvoiceAmountBeforeTax').value || '');
    formData.append('TaxAmount', control.get('Taxes').value || '');
    formData.append('TotalAmount', control.get('TotalAmount').value || '');
    formData.append('ItemNo', `${index}`);
    formData.append('InvoiceFile', file as any);
    const url = `${this.Environment.authConfig.wmsmUrl}/api/RtStatement/ValidateAndExtractForeignInvoiceInfo`;

    try {
      const res: any = await this.http.post(url, formData).toPromise();

      if (res && res.status == this.Environment.authConfig.wmsmStatus && res.data && !res.data.extractMessage) {
        const result = res.data;
        // 注意：這裡不再需要 file['fileId'] = result.fileId; (需求 1)

        const recognized = {
          invoiceNo: result.invoiceNo,
          invoiceDate: result.invoiceDate ? new Date(result.invoiceDate) : null,
          totalAmount: result.totalAmount
        };
        let parsedInvoiceDate = null;

        control.patchValue({
          InvoiceNo: recognized.invoiceNo,
          InvoiceDate: recognized.invoiceDate,
          TotalAmount: recognized.totalAmount ? recognized.totalAmount.toFixed(2) : null,
          parsedTotalAmount: recognized.totalAmount,
          InvoiceAmountBeforeTax: null,
          Taxes: null,
          editMode: 'recognized',
          recognizedData: recognized,
          // attachmentList: [file], // 已移除 (需求 1)
        });

        control.get('InvoiceDate').disable();
        control.get('InvoiceNo').disable();
        control.get('TotalAmount').disable();
        control.get('InvoiceAmountBeforeTax').enable();
        control.get('Taxes').enable();

        const msg = this.translate.instant('MsgRecognitionSuccessAmountsNeeded');
        this.NzMessageService.success(msg);
        this.updateForeignAmountCompleteness();

      } else {
        this.NzMessageService.warning(res.msg || this.translate.instant('MsgRecognitionFailed'));
        control.patchValue({ editMode: 'editing', recognizedData: null });
        this.enableManualEdit(index);
      }
    } catch (error) {
      this.NzMessageService.error(this.translate.instant('MsgUploadFailed'));
      console.error('API call failed', error);
      control.patchValue({ editMode: 'editing', recognizedData: null });
      this.enableManualEdit(index);
    } finally {
      this.loading = false;
      this.updateForeignAmountCompleteness();
    }
    return false; // 永遠返回 false，阻止上傳列表顯示附件 (需求 1)
  }


  removeAttachment(index: number, fileToRemove: NzUploadFile): void {
    const control = this.aliases.at(index);
    let attachments = control.get('attachmentList').value || [];

    // 移除指定的檔案
    attachments = attachments.filter(att => att.uid !== fileToRemove.uid);

    // 更新表單值
    control.patchValue({ attachmentList: attachments });

    // 如果移除後沒有附件了，重設並禁用部分輸入框
    if (attachments.length === 0) {
      control.patchValue({
        // InvoiceNo 和 InvoiceDate 的值不清空，讓用戶的輸入保留
        InvoiceAmountBeforeTax: null,
        Taxes: null,
        TotalAmount: null,
        parsedTotalAmount: null, // **清空上限**
        userDecision: 'pending',
        editMode: 'initial' // 重置模式
      });
      control.get('InvoiceSerialNumber').disable();
      // 保持 InvoiceDate 和 InvoiceNo 啟用
      control.get('InvoiceAmountBeforeTax').disable();
      control.get('Taxes').disable();
    }

    this.updateForeignAmountCompleteness();
  }

  validateTotalAmount(i: number): void {
    if (this.currency !== 'RMB') {
      const control = this.aliases.at(i);
      const beforeTaxControl = control.get('InvoiceAmountBeforeTax');
      const taxesControl = control.get('Taxes');

      const beforeTax = parseFloat(beforeTaxControl.value) || 0;
      const taxes = parseFloat(taxesControl.value) || 0;
      const calculatedTotal = beforeTax + taxes;

      // 步驟一：無條件更新含稅總價，提供即時反饋
      // 這一步是無害的，使用者喜歡看到即時的計算結果。
      control.get('TotalAmount').setValue(calculatedTotal.toFixed(2));

      // --- 核心修改：增加觸發彈窗的“守衛”條件 ---
      const isBeforeTaxFilled = beforeTaxControl.value !== null && beforeTaxControl.value !== '';
      const isTaxesFilled = taxesControl.value !== null && taxesControl.value !== '';

      // 步驟二：只有當兩個欄位都填寫了值，才進行衝突檢查
      if (isBeforeTaxFilled && isTaxesFilled) {
        const recognizedTotal = parseFloat(control.get('parsedTotalAmount').value);

        // 步驟三：在滿足守衛條件後，再判斷金額是否衝突
        if (!isNaN(recognizedTotal) && calculatedTotal.toFixed(2) !== recognizedTotal.toFixed(2)) {
          // 只有在這裡，才調用彈窗函數
          this.showConfirmationModal(i, calculatedTotal, recognizedTotal);
        }
      }
      // 如果任一欄位為空，則不會執行任何衝突檢查，使用者可以繼續輸入。
    }
  }

  /**
   * 顯示金額衝突的確認對話框 (此函數保持不變)
   * @param index - 表格行的索引
   * @param userTotal - 使用者手動輸入計算出的總價
   * @param recognizedTotal - AI 識別出的總價
   */
  private showConfirmationModal(index: number, userTotal: number, recognizedTotal: number): void {
    const control = this.aliases.at(index);
    const params = {
      userTotal: userTotal.toFixed(2),
      recognizedTotal: recognizedTotal.toFixed(2)
    };

    this.translate.get([
      'ModalAmountConfirmTitle',
      'ModalAmountConfirmContent',
      'ModalAmountConfirmOkText',
      'ModalAmountConfirmCancelText'
    ], params).subscribe(translations => {

      this.modal.confirm({
        nzTitle: translations['ModalAmountConfirmTitle'],
        nzContent: translations['ModalAmountConfirmContent'],
        nzOkText: translations['ModalAmountConfirmOkText'],
        nzCancelText: translations['ModalAmountConfirmCancelText'],
        nzOnOk: () => {
          // 【選擇一：使用使用者輸入的總和】
          control.get('userDecision').setValue('user');
          const msg = this.translate.instant('MsgUserSumSelected', { index: index + 1 });
          this.NzMessageService.info(msg);
        },
        nzOnCancel: () => {
          // 【選擇二：使用系統識別的金額】
          control.get('userDecision').setValue('system');

          // 【【【 核心修正邏輯 】】】
          // 當用戶在彈窗選擇 "使用系統價" 時，立即檢查當前輸入是否已超限。
          if (userTotal > recognizedTotal) {
            // 如果已超限，則直接清空，而不是做負數調整
            const errorParams = { recognizedTotal: recognizedTotal.toFixed(2) };
            const errorMsg = this.translate.instant('MsgSumExceedsLimit', errorParams);
            this.NzMessageService.error(errorMsg);

            control.patchValue({
              InvoiceAmountBeforeTax: null,
              Taxes: null,
            });
          }

          // 無論如何，都將UI上的含稅總價設定為識別的總價
          control.get('TotalAmount').setValue(recognizedTotal.toFixed(2));

          // 如果上面清空了，這裡會讓總價顯示為 0.00
          // 如果沒超限，則保留原輸入
          this.calculateSum(index);

          const infoMsg = this.translate.instant('MsgSystemSumSelected', { index: index + 1 });
          this.NzMessageService.info(infoMsg.replace('稅金已被自動調整以匹配', '總價已鎖定為')); // 優化提示文本
        }
      });
    });
  }

  /**
 * 新增：僅用於即時計算總和並更新UI，在 (input) 事件觸發
 */
  calculateSum(i: number): void {
    if (this.currency !== 'RMB') {
      const control = this.aliases.at(i);
      const beforeTax = parseFloat(control.get('InvoiceAmountBeforeTax').value) || 0;
      const taxes = parseFloat(control.get('Taxes').value) || 0;
      control.get('TotalAmount').setValue((beforeTax + taxes).toFixed(2));
      this.updateForeignAmountCompleteness();
    }
  }

  validateAndConfirm(i: number): void {
    if (this.currency !== 'RMB') {
      const control = this.aliases.at(i);
      const userDecision = control.get('userDecision').value;

      // 如果用戶已決定自定義，則不執行任何驗證
      if (userDecision === 'user') {
        return;
      }

      const beforeTaxControl = control.get('InvoiceAmountBeforeTax');
      const taxesControl = control.get('Taxes');
      const recognizedTotal = parseFloat(control.get('parsedTotalAmount').value);

      // 檢查是否有有效的識別總價
      if (isNaN(recognizedTotal)) {
        return;
      }

      const calculatedTotal = parseFloat(control.get('TotalAmount').value) || 0;

      const isBothFilled = (beforeTaxControl.value !== null && beforeTaxControl.value !== '') &&
        (taxesControl.value !== null && taxesControl.value !== '');

      if (userDecision === 'pending' && isBothFilled && calculatedTotal.toFixed(2) !== recognizedTotal.toFixed(2)) {
        // 情況一：首次發現衝突，彈出確認框
        this.showConfirmationModal(i, calculatedTotal, recognizedTotal);

      } else if (userDecision === 'system') {
        // 情況二：用戶已選擇遵循系統總價，執行嚴格上限卡控

        // 【【【 核心修正邏輯 】】】
        // 只要計算總和超過識別總價，就報錯並清空。
        // 這個判斷對 blur 事件觸發時的任一輸入框都有效。
        if (calculatedTotal > recognizedTotal) {
          const params = { recognizedTotal: recognizedTotal.toFixed(2) };
          const errorMsg = this.translate.instant('MsgSumExceedsLimit', params);

          this.NzMessageService.error(errorMsg);

          // 清空兩個輸入框，強制用戶重新輸入
          control.patchValue({
            InvoiceAmountBeforeTax: null,
            Taxes: null
          });

          // 觸發 calculateSum 以更新顯示的總價為 0.00
          this.calculateSum(i);
        }
      }

      this.updateForeignAmountCompleteness();
    }
  }

  /**
   * 還原為系統識別的結果
   * @param index 行索引
   */
  restoreRecognizedData(index: number): void {
    const control = this.aliases.at(index);
    const recognized = control.get('recognizedData').value;

    if (control && recognized) {
      control.patchValue({
        InvoiceNo: recognized.invoiceNo,
        InvoiceDate: recognized.invoiceDate,
        TotalAmount: recognized.totalAmount ? recognized.totalAmount.toFixed(2) : null,
        parsedTotalAmount: recognized.totalAmount,
        InvoiceAmountBeforeTax: null,
        Taxes: null,
        editMode: 'recognized'
      });

      control.get('InvoiceDate').disable();
      control.get('InvoiceNo').disable();
      control.get('TotalAmount').disable();
      control.get('InvoiceAmountBeforeTax').enable();
      control.get('Taxes').enable();

      this.NzMessageService.success(this.translate.instant('MsgRestoredSuccess'));
      this.updateForeignAmountCompleteness();
    }
  }


  /**
 * 更新收貨清單中的發票序號下拉選單
 * 這個函式會在每次發票行變動時被調用
 */
  updateSerialNumberList(): void {
    // 從 FormArray 中直接獲取所有發票行的原始值，包括被禁用的欄位
    const serialNumbers = this.aliases.getRawValue().map(row => row.InvoiceSerialNumber);

    // 過濾掉空值並確保唯一性，然後更新列表
    this.InvoiceInfoSerialNumberList = [...new Set(serialNumbers.filter(sn => sn != null))];

    // 【【【 核心修改 】】】
    // 在這裡調用檢查函式，同步更新提交按鈕的禁用狀態
    this.checkInvoiceInfo();
    this.updateForeignAmountCompleteness();
  }

  shouldShowComparison(control: FormGroup, field: 'InvoiceNo' | 'InvoiceDate' | 'TotalAmount'): boolean {
    if (this.currency === 'RMB' || !control) {
      return false;
    }

    const recognized = this.getRecognizedPrimitive(control, field);
    const manual = this.getManualPrimitive(control, field);

    if (recognized === null || manual === null) {
      return false;
    }

    if (typeof recognized === 'number' && typeof manual === 'number') {
      return Math.abs(manual - recognized) > 0.000001;
    }

    return recognized !== manual;
  }

  getComparisonDisplay(control: FormGroup, field: 'InvoiceNo' | 'InvoiceDate' | 'TotalAmount'): string {
    const recognized = this.getRecognizedPrimitive(control, field);

    if (recognized === null) {
      return '';
    }

    if (typeof recognized === 'number') {
      return this.formatNumberForDisplay(recognized);
    }

    return recognized;
  }

  private getManualPrimitive(control: FormGroup, field: 'InvoiceNo' | 'InvoiceDate' | 'TotalAmount'): string | number | null {
    switch (field) {
      case 'InvoiceNo': {
        const value = control.get('InvoiceNo')?.value;
        return this.normalizeStringValue(value);
      }
      case 'InvoiceDate': {
        const value = control.get('InvoiceDate')?.value;
        if (!value) {
          return null;
        }
        return this.formatDateToYYYYMMDD(value);
      }
      case 'TotalAmount': {
        const value = control.get('TotalAmount')?.value;
        if (value === null || value === undefined || value === '') {
          return null;
        }
        const parsed = parseFloat(value);
        return isNaN(parsed) ? null : parsed;
      }
      default:
        return null;
    }
  }

  private getRecognizedPrimitive(control: FormGroup, field: 'InvoiceNo' | 'InvoiceDate' | 'TotalAmount'): string | number | null {
    const recognizedData = control.get('recognizedData')?.value;

    switch (field) {
      case 'InvoiceNo':
        return this.normalizeStringValue(recognizedData?.invoiceNo);
      case 'InvoiceDate':
        return recognizedData?.invoiceDate ? this.formatDateToYYYYMMDD(recognizedData.invoiceDate) : null;
      case 'TotalAmount': {
        const value = control.get('parsedTotalAmount')?.value;
        if (value === null || value === undefined || value === '') {
          return null;
        }
        const parsed = parseFloat(value);
        return isNaN(parsed) ? null : parsed;
      }
      default:
        return null;
    }
  }

  private normalizeStringValue(value: any): string | null {
    if (value === null || value === undefined) {
      return null;
    }
    const normalized = value.toString().trim();
    return normalized === '' ? null : normalized;
  }

  private formatNumberForDisplay(value: number): string {
    if (value === null || value === undefined || isNaN(value)) {
      return '';
    }
    return value.toFixed(2);
  }

  private formatManualNumberForInput(value: number | string | null): string {
    if (value === null || value === undefined) {
      return '';
    }

    if (typeof value === 'string') {
      const trimmed = value.trim();
      return trimmed;
    }

    if (!isFinite(value)) {
      return '';
    }

    const strValue = value.toString();
    if (strValue.includes('e') || strValue.includes('E')) {
      return value
        .toFixed(6)
        .replace(/0+$/g, '')
        .replace(/\.$/, '');
    }

    return strValue;
  }

  toggleLock(index: number): void {
    if (this.currency === 'RMB') {
      return;
    }
    const control = this.aliases.at(index) as FormGroup;
    if (!control) {
      return;
    }
    const lockControl = control.get('isLocked');
    if (!lockControl) {
      return;
    }
    const nextState = !lockControl.value;
    lockControl.setValue(nextState);
    this.setManualFieldState(control, nextState);
    this.updateForeignAmountCompleteness();
  }

  private setManualFieldState(control: FormGroup, disable: boolean): void {
    if (this.currency === 'RMB' || !control) {
      return;
    }
    const targetFields = ['InvoiceDate', 'InvoiceNo', 'InvoiceAmountBeforeTax', 'Taxes', 'TotalAmount'];
    targetFields.forEach(field => {
      const targetControl = control.get(field);
      if (targetControl) {
        if (disable) {
          targetControl.disable({ emitEvent: false });
        } else {
          targetControl.enable({ emitEvent: false });
        }
      }
    });
  }

  private updateForeignAmountCompleteness(): void {
    if (this.currency === 'RMB') {
      this.foreignAmountsIncomplete = false;
      return;
    }

    if (!this.aliases || this.aliases.length === 0) {
      this.foreignAmountsIncomplete = true;
      return;
    }

    const invoiceRows = this.aliases.getRawValue();

    this.foreignAmountsIncomplete = invoiceRows.some(row => {
      const hasInvoiceNo = row.InvoiceNo !== null && row.InvoiceNo !== undefined && row.InvoiceNo !== '';
      if (!hasInvoiceNo) {
        return false;
      }
      const amountEmpty = row.InvoiceAmountBeforeTax === null || row.InvoiceAmountBeforeTax === undefined || row.InvoiceAmountBeforeTax === '';
      const taxEmpty = row.Taxes === null || row.Taxes === undefined || row.Taxes === '';
      return amountEmpty || taxEmpty;
    });
  }

}
